import React from "react";
import type { JSX } from "react";

interface CyberpunkGridProps {
  width?: number;
  height?: number;
  color?: string;
  opacity?: number;
  className?: string;
}

export function CyberpunkGrid({
  width = 100,
  height = 100,
  color = "rgba(255,255,0,0.3)",
  opacity = 0.2,
  className = "",
}: CyberpunkGridProps): JSX.Element {
  return (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ opacity }}
    >
      <defs>
        <pattern
          id="cyberpunkGrid"
          width="20"
          height="20"
          patternUnits="userSpaceOnUse"
        >
          <path
            d="M 20 0 L 0 0 0 20"
            fill="none"
            stroke={color}
            strokeWidth="0.5"
          />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#cyberpunkGrid)" />
    </svg>
  );
}
